import { render, staticRenderFns } from "./ProjectListDisplayType.vue?vue&type=template&id=089334fc&scoped=true&"
import script from "./ProjectListDisplayType.vue?vue&type=script&lang=ts&"
export * from "./ProjectListDisplayType.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectListDisplayType.vue?vue&type=style&index=0&id=089334fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089334fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
